import { SimpleTabs } from "common/components/tabs/SimpleTabs";
import { H2 } from "common/components/Typography";
import { YoutubeVideoIframe } from "domain/article/YoutubeVideoIframe";
import { useFinishContent } from "domain/common/content-mutations";
import React, { useEffect } from "react";
import { ContentBreadcrumbFragment_context } from "__generated__/types";
import styles from "./Article.module.css";

interface Props {
  title: string;
  id: string;
  youtubeVideoId?: string | null;
  tabs?: Array<{
    title: string;
    content: React.ReactNode;
  }>;
  onFinishedElement?: () => void;
  containerType:
    | ContentBreadcrumbFragment_context["__typename"]
    | "SelfAssessment"
    | undefined;
  isSyllabus?: boolean;
}

export const Article: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  youtubeVideoId,
  tabs,
  id,
  onFinishedElement,
  isSyllabus,
  containerType,
  children,
}) => {
  const { handleFinishContent } = useFinishContent();

  useEffect(() => {
    async function handleFinishContentAndRefetch() {
      await handleFinishContent(id);

      if (onFinishedElement) {
        onFinishedElement();
      }
    }

    if (isSyllabus && containerType !== "SelfAssessment") {
      void handleFinishContentAndRefetch();
    }
  }, [id]);

  return (
    <section className={styles.container}>
      <H2>{title}</H2>
      {youtubeVideoId && (
        <section className={styles.videoContainer}>
          <YoutubeVideoIframe youtubeId={youtubeVideoId} />
        </section>
      )}
      {children}
      {!!tabs?.length && <SimpleTabs content={tabs} />}
    </section>
  );
};
